export const routePaths = {
  home: { path: '/', name: 'home' },
  dashboard: { path: '/dashboard', name: 'dashboard' },
  listCounts: { path: '/list-counts', name: 'list-counts' },
  receiveMeals: { path: '/receive-meals', name: 'receive-meals' },
  serveMeals: { path: '/serve-meals', name: 'serve-meals' },
  offline: { path: '/offline', name: 'offline' },
  privacyPolicy: { path: '/privacy-policy', name: 'privacy-policy' },
  termsOfUse: { path: '/terms-of-use', name: 'terms-of-use' }
};
